module.exports = __webpack_public_path__ + "mobile/img/Outbound-img1.d1fb37b7.png";